import { Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { Loading } from '../../../../general/components/loading';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { ConfirmCheck } from '../../../../theme/coast/icons';

const selector = ({ nextStep: { loading } }: RootState) => ({
  loading,
});

const ApplicationOfflineReviewPage: FC = () => {
  const { loading } = useSelector(selector);
  return (
    <TerminalWizardPage
      icon={<ConfirmCheck />}
      title="That's all for now!"
      subtext={<>We are reviewing your information.</>}
      footer={<YouCanComeBackNote />}
    >
      <Loading open={loading} />
      <Typography variant="inherit" align="center" color="textSecondary">
        We will send you an email as soon as <br />
        we&apos;re ready to proceed with your application.
      </Typography>
    </TerminalWizardPage>
  );
};

export { ApplicationOfflineReviewPage };
